// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"148":"c13b1b84","482":"c13b1b84","523":"c13b1b84"}[chunkId] + ".chunk.css";
};